import * as Config from './config.json';

export const API_ENDPOINT = Config.apiEndpoint;
export const CLIENT_ID = Config.clientId;
export const REDIRECT_URL = Config.redirectUrl;
